import React from 'react';
import { formatPrice } from '../hooks/contractHelper';

export default function RewardModal({ show, setShow, data }) {
    const handleClose = () => setShow(false);
    
    return (
        <div className={`modal fade ${show ? 'show d-block' : ''}`}
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden={!show}
            style={{ display: show ? 'block' : 'none' }}>
            <div class="modal-dialog modal-dialog-centered">
                <div className="modal-content bg-dark">
                    <div className="modal-header">
                        <p className="modal-title fs-5" id="staticBackdropLabel">Total Pending Reward</p>
                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"></button>
                    </div>
                    <div className="modal-body text-center">
                        {data && data.length > 0 ? (
                            data.map((items, key) => (
                                parseFloat(items.balance) > 0 &&
                                <>
                                    <p className='fs-5' key={key}>{formatPrice(items.balance , 5)} {items.symbol}</p>
                                </>
                            ))) : (
                            <span className='fs-5'>No reward</span>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
